export const START_MOVE = "START_MOVE";
export const STOP_MOVE = "STOP_MOVE";
export const MOVE = "MOVE";
export const SELECTED = "SELECTED";
